import CryptoJS from 'crypto-js'
import { http } from '@vt/apis/lib-ex'

const diaoyanAESkey =
  process.env.REACT_APP_DEP === 'dev' ? '1234567887654321' : '7um6ei6ij4u910cx'

const baseKey = CryptoJS.enc.Utf8.parse(diaoyanAESkey)
const getApiVersion = () => {
  // // 测试用
  // return '/diaoyanapi'

  // 真实地址
  // eslint-disable-next-line no-unreachable
  return process.env.REACT_APP_DEP === 'dev'
    ? 'https://test.diaoyan001.com' // https://test.diaoyan001.com
    : 'https://diaoyan001.com'
}

// export const encryptStr = (source) => {
//   if (!source) return ''
//   return CryptoJS.AES.encrypt(source, diaoyanAESkey, {
//     iv: diaoyanAESkey,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   }).toString()
// }

export const encryptStr = (source) => {
  if (!source) return ''
  const encrypt = CryptoJS.AES.encrypt(source, baseKey, {
    iv: baseKey,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  // CryptoJS.enc.Base64.parse(encrypt)
  return encrypt.toString(CryptoJS.format.Hex).toUpperCase()
}

// export const decryptStr = (source) => {
//   if (!source) return ''
//   return CryptoJS.AES.decrypt(source, diaoyanAESkey, {
//     iv: diaoyanAESkey,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   }).toString(CryptoJS.enc.Utf8)
// }

export const decryptStr = (source) => {
  if (!source) return ''
  const encryptedHex = CryptoJS.enc.Hex.parse(source)
  const encryptedBase64 = CryptoJS.enc.Base64.stringify(encryptedHex)
  return CryptoJS.AES.decrypt(encryptedBase64, baseKey, {
    iv: baseKey,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8)
}

export const getFaceRecognitionState = (indentNo, params) => {
  return http()
    .get(
      `${getApiVersion()}/fill/api/v2/queryFaceVerifyLastRecord?indentNo=${indentNo}&token=null`,
      params
    )
    .json()
}

export const getFaceAuth = (indentNo, params) => {
  return http()
    .get(
      `${getApiVersion()}/fill/api/v2/faceAuth?identEncrypted=${indentNo}`,
      params
    )
    .json()
}

export const getSignDetailForInvestigation = (indentNo, appId, params) => {
  return http()
    .get(
      `${getApiVersion()}/fill/api/v2/brief/signDetailForInvestigation?identEncrypted=${indentNo}&briefType=1&subProjectCategory=2&subProjectId=${appId}`,
      params
    )
    .json()
}

export const roleList = [
  // 'zdy_jianchayuan',
  'zdy_shenheyuan',
  // 'zdy_guanliyuan',
  // 'zdy_huanweishenheyuan',
]

export const orgNameList = ['环卫中心检查A组']

export const userWhiteList = []

// import { computed } from 'vue'
// import { useAppStore, useAuthStore } from '@cl-comps/store'

// // 用于提供给表格组件的唯一key
// export const useFaceRecogUniqKey = (faceRecogValue: string | undefined) => {
//   const { projectSlug, appSlug } = useAppStore()
//   const { userInfo } = useAuthStore()

//   const faceRecogUniqKey = computed(() => {
//     return `${projectSlug}-${appSlug}-${faceRecogValue}-${userInfo.id}`
//   })
//   return faceRecogUniqKey.value
// }

// export const getStorageFaceRecog = (faceRecogKey: string) => {
//   const item = localStorage.getItem(`faceRecogIndex-${faceRecogKey}`)
//   return item
// }

// export const updateStorageFaceRecog = (faceRecogKey: string, id: string) => {
//   localStorage.setItem(`faceRecogIndex-${faceRecogKey}`, id)
// }
